import React, { Component } from "react";
import MaskedInput from "react-text-mask";
import TextInputField, { Props as TP } from "./TextInputField";

interface Pros extends TP {
}

export function isSafari() {
	return navigator.userAgent.toLowerCase().indexOf( "safari" ) > -1 && navigator.userAgent.toLowerCase().indexOf( "chrome" ) === -1;
}

export function isIOS() {
	return /iPad|iPhone|iPod/.test( navigator.platform );
}

export function isiPad() {
	return navigator.userAgent.includes( "Macintosh" ) && navigator.maxTouchPoints >= 1;
}

const isSimple = isSafari() || isIOS() || isiPad();

class EidInputField extends Component<Pros> {
	render() {
		const { children, ...others } = this.props;
		if ( isSimple ) {
			return <TextInputField
				maxLength={ 15 }
				{ ...others }
			>
				{ children }
			</TextInputField>;
		} else {

		}
		return (
			<TextInputField
				{ ...others }
				customInput={ <MaskedInput
					keepCharPositions={ true }
					guide={ true }
					showMask={ true }
					mask={ [ "7", "8", "4", "-", /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/ ] }
				/> }
			>{ children }
			</TextInputField>
		);
	}
}

export default EidInputField;

